<template>
<v-layout row wrap>
    <v-flex xs6>
        <v-btn dark @click="startRecording()">START</v-btn>
        <v-btn dark @click="stopRecording()">STOP</v-btn>
    </v-flex>
    <v-flex xs6>
       <audio id="recordedAudio"></audio>
        <a id="audioDownload">download</a>
    </v-flex>
</v-layout>
</template>

<script>

    export default {
        data() {
            return {
                rec: '',
                audioChunks: []
            }
        },
        components: {},
        mounted() {

        },
        methods: {
            startRecording() {
                let options = {
                    audioBitsPerSecond : 128000,
                    mimeType : 'audio/webm; codecs=opus'
                };
                navigator.mediaDevices.getUserMedia({audio: true, video: false})
                    .then((stream) => {
                        this.rec = new MediaRecorder(stream, options);
                        this.audioChunks = [];
                        this.rec.start();
                        this.rec.ondataavailable = e => {
                            this.audioChunks.push(e.data);
                            console.log("chucks", this.audioChunks);
                            if (this.rec.state === "inactive") {
                                console.log("FINE");
                                let blob = new Blob(this.audioChunks, {type: 'audio/ogg; codecs=opus'});
                                console.log("BLOB", blob);
                                recordedAudio.src = URL.createObjectURL(blob);
                                recordedAudio.controls = true;
                                recordedAudio.autoplay = true;
                                audioDownload.href = recordedAudio.src;
                                audioDownload.download = 'mp3';
                                audioDownload.innerHTML = 'download';
                            }
                        }
                    })
                    .catch(function (e) {
                        console.log(e)
                    });
            },
            stopRecording() {
                this.rec.stop();
            }
        }
    }
</script>
